import { render, staticRenderFns } from "./car-info.vue?vue&type=template&id=5425139f&scoped=true"
import script from "./car-info.vue?vue&type=script&lang=js"
export * from "./car-info.vue?vue&type=script&lang=js"
import style0 from "./car-info.vue?vue&type=style&index=0&id=5425139f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5425139f",
  null
  
)

export default component.exports